import setBaseColor from './set-base-color';
import { colorToSurfaceMap } from '../constants/colors-maps';

const resetColorSchemeColors = ({ colorKey: backgroundColorKey, colorPalette, parentPalette }) => {
  const surface = colorToSurfaceMap[backgroundColorKey];
  const initialColors = parentPalette ? parentPalette.colors : colorPalette.colors;
  const advancedColors = colorPalette.advancedColors || {};

  const updatedPalette = setBaseColor({
    colorKey: backgroundColorKey,
    color: initialColors[backgroundColorKey],
    colorPalette,
  });

  const filteredAdvancedColors = Object.fromEntries(
    Object.entries(advancedColors).filter(([key]) => !key.includes(surface))
  );

  return { ...updatedPalette, advancedColors: filteredAdvancedColors };
};

export default resetColorSchemeColors;
